/**
 * Export component file to be used on project
 */

import CheckoutPlans from './CheckoutPlans';
export default CheckoutPlans;